import { createSlice } from "@reduxjs/toolkit";

import {
  clearSelectedCountry,
  getFreeProxiesForExport,
  getProxies,
  getProxyPagination,
  openDropDown,
  paginationProxySave,
  serverProxySave,
  toFirstRenderFalse,
} from "./freeProxy.operations";
import {
  clearSelectedCountryReducer,
  exportFreeProxiesFulfilledReducer,
  getFreeProxyFulfilledReducer,
  getPaginationDataFulfilledReducer,
  getPendingReducer,
  getRejectedReducer,
  openDropDownReducer,
  toFirstRenderFalseFulfilledReducer,
} from "./freeProxy.reducer";
import { freeProxyInitialState } from "./freeProxyInitialState";

const freeProxySlice = createSlice({
  name: "freeProxy",
  initialState: freeProxyInitialState,

  extraReducers: builder =>
    builder
      .addCase(serverProxySave, getFreeProxyFulfilledReducer)
      .addCase(paginationProxySave, getPaginationDataFulfilledReducer)
      .addCase(openDropDown, openDropDownReducer)
      .addCase(clearSelectedCountry, clearSelectedCountryReducer)
      .addCase(toFirstRenderFalse, toFirstRenderFalseFulfilledReducer)
      .addCase(getProxies.pending, getPendingReducer)
      .addCase(getProxies.fulfilled, getFreeProxyFulfilledReducer)
      .addCase(getProxies.rejected, getRejectedReducer)

      // Here  does not loading need
      .addCase(getProxyPagination.fulfilled, getPaginationDataFulfilledReducer)
      .addCase(
        getFreeProxiesForExport.fulfilled,
        exportFreeProxiesFulfilledReducer,
      ),
});

export const FreeProxyAction = {
  getProxies,
  getProxyPagination,
  serverProxySave,
  paginationProxySave,
  openDropDown,
  clearSelectedCountry,
  getFreeProxiesForExport,
  toFirstRenderFalse,
};

export default freeProxySlice.reducer;
